import { useEffect } from 'react'
import { useCampaignSlug } from './useCampaignSlug'

const useDeployTimeStamp = () => {
  const { LOCAL_STORAGE_DEPLOY_TIMESTAMP_KEY } = useCampaignSlug()
  useEffect(() => {
    const setTimestamp = async () => {
      const response = await fetch(`${process.env.NEXT_PUBLIC_SITEURL}/deploy_time.json`, {
        method: 'GET',
        cache: 'no-store',
      })
      const data = await response.json()
      const deployTimestampNew = data.timestamp
      const DEPLOY_TIMESTAMP_OLD = localStorage.getItem(LOCAL_STORAGE_DEPLOY_TIMESTAMP_KEY)
      if (DEPLOY_TIMESTAMP_OLD === null) {
        location.reload()
        localStorage.setItem(LOCAL_STORAGE_DEPLOY_TIMESTAMP_KEY, deployTimestampNew)
      } else if (DEPLOY_TIMESTAMP_OLD !== deployTimestampNew) {
        localStorage.setItem(LOCAL_STORAGE_DEPLOY_TIMESTAMP_KEY, deployTimestampNew)
        location.reload()
      }
    }
    setTimestamp()
  }, [])
}

export default useDeployTimeStamp
